<div class="colab-manager-content-component colab-import fade-in-animation">
  <div class="row" style="margin: 0;">
    <div class="col-md-12 col-sm-12">
      <h1 class="no-margin">{{ 'COMPANY.MANAGER.IMPORT.SECTION_TITLE' | translate }}</h1>
      <p class="text-wrp">
        {{ 'COMPANY.MANAGER.IMPORT.DESCRIPTION_TEXT1' | translate }}
        <br />{{ 'COMPANY.MANAGER.IMPORT.DESCRIPTION_TEXT3' | translate }}
        <br />{{ 'COMPANY.MANAGER.IMPORT.DESCRIPTION_TEXT2' | translate }}
      </p>
        <ul>
          <li>{{ 'COMPANY.MANAGER.IMPORT.TIP1' | translate }}</li>
          <li>{{ 'COMPANY.MANAGER.IMPORT.TIP2' | translate }}</li>
          <li>{{ 'COMPANY.MANAGER.IMPORT.TIP3' | translate }}</li>
          <li>{{ 'COMPANY.MANAGER.IMPORT.TIP4' | translate }}</li>
          <li>{{ 'COMPANY.MANAGER.IMPORT.TIP5' | translate }}</li>
          <li>{{ 'COMPANY.MANAGER.IMPORT.TIP6' | translate }}</li>
          <li>{{ 'COMPANY.MANAGER.IMPORT.TIP7' | translate }}</li>
        </ul>
      <a href="https://s3.amazonaws.com/colaboradores-live/arquivos-modelo/modelo_importacao_allya_v1-0-0.xlsx">
        <button class="btn btn-pink">Planilha Modelo</button>
      </a>

      <ng-core-file-upload
        [disabled]="isProcessing"
        [title]="'Lista de colaboradores'"
        [subtitle]="'Tamanho Máx.: 5000 linhas.'">
      </ng-core-file-upload>

      <!--  Log Table-->
      <div class="log-table-area" *ngIf="hasLogs">
        <h2 class="no-margin">{{ 'COMPANY.MANAGER.MENU.LOG_TABLE' | translate }}</h2>
        <table class="table table-borderless">
          <thead>
            <tr><th scope="col">Data e Hora</th><th scope="col">Arquivo</th><th scope="col">Usuário</th><th scope="col">Status</th></tr>
          </thead>
          <tbody>
            <tr #allTheseThings *ngFor="let data of dataLogs; let in = index;" [style.backgroundColor]="(data.status==='processing' || data.status==='received')?'rgba(251, 242, 137, 0.20)':'#fffff'">
              <td class="first-row"> {{ data.datetime | date: 'dd/MM/yyyy HH:mm' }}</td>
              <td><a>{{ data.filename }}</a></td>
              <td>{{ data.fullNameUser }}</td>
              <td>{{statusList[data?.status]}}</td>
              <td class="last-row" *ngIf="data.status==='finished' || data.status==='reverted-hard' || data.status==='reverted-soft'">
                <span class="register-sucess"> <i class="fa fa-check-circle"></i>
                  {{data.importedCount}} {{ 'COMPANY.MANAGER.IMPORT.ROWS_WITH_SUCCESS' | translate }} </span><br> <span class="register-error"><i class="fa fa-times-circle"></i>
                  {{data.errorCount}} {{ 'COMPANY.MANAGER.IMPORT.ROWS_WITH_ERRORS' | translate }} </span><br>
                <span *ngIf="data.status==='finished' && data.errorCount!==0"> <i class="fa fa-level-up"></i>
                  <a class="link-download" (click)="getErrosArchive(data.id, data.filename)"> Fazer Download </a></span>
              </td>
              <td class="last-row" *ngIf="data.status==='processing' || data.status==='received'">
                  <svg class="barLoading" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.0" width="128px" height="16px" viewBox="0 0 128 16" xml:space="preserve"><rect x="0" y="0" width="100%" height="100%" fill="#FFFFE5" /><g><path d="M-22.949-5.576l4.525,4.525L-41.051,21.576l-4.525-4.525Zm19.2,0L0.776-1.051-21.851,21.576l-4.526-4.525Zm19.2,0,4.525,4.525L-2.651,21.576l-4.525-4.525Zm19.2,0,4.525,4.525L16.549,21.576l-4.525-4.525Zm19.2,0,4.525,4.525L35.749,21.576l-4.526-4.525Zm38.4,0,4.525,4.525L74.149,21.576l-4.525-4.525Zm-19.2,0,4.525,4.525L54.949,21.576l-4.526-4.525Zm38.4,0,4.525,4.525L93.349,21.576l-4.526-4.525Zm19.2,0,4.525,4.525L112.549,21.576l-4.525-4.525Zm19.2,0,4.525,4.525L131.749,21.576l-4.525-4.525Z" fill="#c4b516" fill-opacity="1"/><animateTransform attributeName="transform" type="translate" from="0 0" to="-19 0" dur="1080ms" repeatCount="indefinite"/></g></svg>
                  <span class="subtitle-barloading" *ngIf="((data.importedCount>0)||(data.errorCount>0))">{{processedFiles[in].totalProcessed>data.totalProcessed?processedFiles[in].totalProcessed:data.totalProcessed}}/{{data.totalSent}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- / Log Table-->
    </div>
  </div>
</div>
